import {
  ButtonIcon,
  Chip,
  EncoreProvider,
  Flex,
  Focusable,
  IconX,
} from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

import { type FilterViewerComponentProps } from './provider';

import styles from './ToggleFilterChip.module.css';

export const ToggleFilterChip = ({
  filter,
  onRemove,
}: FilterViewerComponentProps<boolean>) => {
  const removeFilterLabel = `Remove ${filter.label} filter`;
  const chip = (
    <Chip
      className={styles.chip}
      variant="bordered"
      type="button"
      aria-pressed
      data-filter-id={filter.id}
      onClick={onRemove}
     data-track-source-anchor="2c7afe6fd9;toggle-filter-chip">
      {filter.label}
    </Chip>
  );

  return (
    <EncoreProvider config={{ next: ['chip'] }}>
      <Flex inline alignItems="center" className={styles.toggleChip}>
        {filter.description ? (
          <TooltipRoot>
            <Focusable>{chip}</Focusable>
            <Tooltip>{filter.description}</Tooltip>
          </TooltipRoot>
        ) : (
          chip
        )}
        <TooltipRoot>
          <ButtonIcon
            className={styles.removeButton}
            variant="tertiary"
            size="small"
            hasNoInteractiveBackground
            aria-label={removeFilterLabel}
            onClick={onRemove}
           data-track-source-anchor="5c2ed70c8a;toggle-filter-chip-button-icon;low">
            <IconX aria-hidden />
          </ButtonIcon>
          <Tooltip>{removeFilterLabel}</Tooltip>
        </TooltipRoot>
      </Flex>
    </EncoreProvider>
  );
};
